export const gutterWidth = 32;

const grid = {
  gutterWidth,
  breakpoints: [576, 768, 992, 1200, 1400, 1500, 1630],
  containerWidths: [540, 740, 1100, 1150, 1450, 1550, 1750]
};

export default grid;
